import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: false,
  token: null,
  user: {}
};

const authenticationSlice = createSlice({
  name: 'authen',
  initialState,
  reducers: {
    signin: (state, action) => {
      state.status = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    signout: (state) => {
      state.status = false;
      state.token = null;
    },
  }
});

export const selectAuthen = (state = {}) => state.authen;

export const { signin, signout } = authenticationSlice.actions;

export default authenticationSlice.reducer;
